import React from "react";
import { Box } from "@mui/material";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import { useNavigate } from "react-router";

import CustomCircleButton from "../../CustomCircleButton";

const ProfileHeaderNavBar = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        backgroundColor: "white.main",
        alignItems: "center",
        padding: "8px 0px 8px 0px",
        zIndex: 2,
        position: "fixed",
        right: "16px",
        left: "16px",
      }}
    >
      <CustomCircleButton
        onClick={(e) => {
          navigate(-1);
        }}
        width='48px'
        height='48px'
        bgColor='white.main'
        color='black.main'
        bShadow='none'
        border='2px solid'
        hoverBgColor='white.main'
        hoverColor='black.main'
        activeBgColor='black.main'
        activeColor='white.main'
      >
        <ArrowBackIosNewRoundedIcon sx={{ fontSize: "32px" }} />
      </CustomCircleButton>

      <div style={{ marginLeft: "-30px" }}>Edit profile</div>
      <span></span>
    </Box>
  );
};

export default ProfileHeaderNavBar;
